'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const WeatherChart = dynamic(() => import('@/app/service-ai/components/WeatherForecastChart'), { ssr: false });

const forecast = [
  { id: 'wf-wed', day: 'Wed Jul 1', high: '102°F', low: '74°F', calls: 83, normal: 82, color: 'text-warning' },
  { id: 'wf-thu', day: 'Thu Jul 2', high: '108°F', low: '79°F', calls: 127, normal: 82, color: 'text-danger' },
  { id: 'wf-fri', day: 'Fri Jul 3', high: '106°F', low: '77°F', calls: 119, normal: 82, color: 'text-danger' },
  { id: 'wf-sat', day: 'Sat Jul 4', high: '104°F', low: '76°F', calls: 108, normal: 82, color: 'text-danger' },
  { id: 'wf-sun', day: 'Sun Jul 5', high: '99°F', low: '72°F', calls: 94, normal: 82, color: 'text-warning' },
  { id: 'wf-mon', day: 'Mon Jul 6', high: '95°F', low: '70°F', calls: 88, normal: 82, color: 'text-warning' },
  { id: 'wf-tue', day: 'Tue Jul 7', high: '91°F', low: '68°F', calls: 82, normal: 82, color: 'text-foreground' },
];

const recommendations = [
  { id: 'rec-001', action: 'Add 4 surge technicians for Thu–Sat', priority: 'critical' },
  { id: 'rec-002', action: 'Pre-position R-410A at 3 warehouses', priority: 'high' },
  { id: 'rec-003', action: 'Send proactive maintenance SMS to 842 members', priority: 'high' },
  { id: 'rec-004', action: 'Extend dispatch hours to 9 PM Thu–Fri', priority: 'medium' },
];

export default function WeatherIntelligencePanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-semibold text-foreground">Weather Forecast Intelligence</h3>
            <p className="text-xs text-muted-foreground mt-0.5">NWS Orange County · Demand forecasting</p>
          </div>
          <div className="text-right">
            <div className="text-3xl font-bold text-danger font-tabular">108°F</div>
            <div className="text-xs text-muted-foreground">Thu Jul 2 forecast</div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4">
        {/* Alert banner */}
        <div className="bg-danger/10 border border-danger/20 rounded-md p-3 mb-4">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-danger text-xs font-semibold">⚠ Excessive Heat Warning — NWS</span>
          </div>
          <p className="text-xs text-foreground">4-day heat event. Expected 54% surge in emergency no-cooling calls. 4 additional technicians auto-scheduled for 7 AM Thursday.</p>
        </div>

        {/* Forecast chart */}
        <WeatherChart />

        {/* Day-by-day */}
        <div className="mt-3 space-y-1.5">
          {forecast?.map((d) => (
            <div key={d?.id} className="flex items-center gap-3 text-xs">
              <span className="text-muted-foreground w-20 flex-shrink-0">{d?.day}</span>
              <span className={`font-semibold font-tabular w-14 flex-shrink-0 ${d?.color}`}>{d?.high}</span>
              <div className="flex-1 bg-muted rounded-full h-1.5 overflow-hidden">
                <div
                  className={`h-1.5 rounded-full ${d?.calls > 100 ? 'bg-danger' : d?.calls > 85 ? 'bg-warning' : 'bg-success'}`}
                  style={{ width: `${(d?.calls / 130) * 100}%` }}
                />
              </div>
              <span className={`font-tabular font-semibold w-8 text-right ${d?.calls > 100 ? 'text-danger' : d?.calls > 85 ? 'text-warning' : 'text-success'}`}>{d?.calls}</span>
              <span className="text-muted-foreground">calls</span>
            </div>
          ))}
        </div>

        {/* AI Recommendations */}
        <div className="mt-4 pt-3 border-t border-border">
          <div className="text-xs font-semibold text-foreground mb-2">AI Recommendations</div>
          <div className="space-y-1.5">
            {recommendations?.map((r) => (
              <div key={r?.id} className="flex items-start gap-2">
                <span className={`w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0 ${r?.priority === 'critical' ? 'bg-danger' : r?.priority === 'high' ? 'bg-warning' : 'bg-secondary'}`} />
                <span className="text-xs text-foreground">{r?.action}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}